export function ellipsis() {
    return {
        "white-space": "nowrap",
        overflow: "hidden",
        "text-overflow": "ellipsis",
    };
}
